/**
 * Landing placeholder routes — AR copy.
 *
 * IMPORTANT — Arabic source order:
 *   Arabic values below are stored in **logical (typed) order** — the same
 *   order a person types in Arabic. The browser handles right-to-left visual
 *   rendering when `<html dir="rtl">` is set. Do NOT manually reverse the
 *   characters or words. Any LTR rendering you see in non-bidi-aware viewers
 *   (some chat UIs, terminal emulators without RTL support) is a rendering
 *   artifact, not a storage issue.
 *
 * Authority:
 *   DEC-048, DEC-049, DEC-050, PO-supplied AR placeholder copy.
 */

export const landingPlaceholdersAr = {
  'landing.placeholders.register.title': 'التسجيل قريبًا',
  'landing.placeholders.register.body':
    'سيتم فتح التسجيل في ووركرايز بعد ربط إعداد الحسابات.',
  'landing.placeholders.plans.title': 'الخطط قريبًا',
  'landing.placeholders.plans.body':
    'سيتم نشر خطط ووركرايز بعد تجهيز الاشتراكات.',
} as const;

export type LandingPlaceholdersAr = typeof landingPlaceholdersAr;
